<template>
  <chart-container :title="title">
    <div class="mx-2 my-1 mx-md-6 mt-md-2">
      <vue-word-cloud
        :font-size-ratio="3"
        :style="computedStyle"
        :words="computedWords"
        :color="getWordColor"
        font-family="Roboto"
      >
        <template slot-scope="{ text, weight, word }">
          <div
            :title="weight"
            :style="{
              cursor: 'pointer',
            }"
            @click="onWordClick(word)"
          >
            {{ text }}
          </div>
        </template>
      </vue-word-cloud>
    </div>
  </chart-container>
</template>

<script>
import _merge from "lodash.merge";
import ChartContainer from "@/components/dashboard/ChartContainer.vue";

export default {
  components: {
    ChartContainer,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    height: {
      type: Number,
      required: false,
    },
  },
  methods: {
    getWordColor([, weight]) {
      if (weight > 2.5) {
        return "#178CA4";
      } else if (weight > 2) {
        return "#717171";
      } else if (weight > 1.5) {
        return "#74818c";
      } else {
        return "#b9c0c5";
      }
    },
    onWordClick(word) {
      this.$emit("filter", [
        {
          source: "wordcloud",
          text: word[0],
        },
      ]);
    },
  },
  computed: {
    computedWords() {
      const totalWords = this.options.words.length;
      const wordsSorted = [...this.options.words].sort((w1, w2) =>
        w2[1] > w1[1] ? 1 : -1
      );
      return wordsSorted.map((word, i) => {
        if (i < 3) {
          return [word[0], 3.5];
        } else if (i < 0.2 * totalWords) {
          return [word[0], 2.5];
        } else if (i < 0.5 * totalWords) {
          return [word[0], 2];
        } else if (i < 0.8 * totalWords) {
          return [word[0], 1.5];
        } else {
          return [word[0], 1];
        }
      });
    },
    computedStyle() {
      const { height, width } = this.options;
      const localOptions = {
        height: this.computedHeigth + "px",
        width: "100%",
      };
      return _merge({}, localOptions, { height, width });
    },
    computedHeigth() {
      switch (this.height) {
        case 185:
          return 183;
        case 200:
          return 203;
        case 300:
          return 303;
        case 340:
          return 343;
        default:
          return this.height + 3;
      }
    },
  },
};
</script>